import { useState } from 'react'
import { BaseFeedbackConIcona, BaseButtons, sx } from '@lucan/base-ui'
import { OPERAZIONI } from 'configuration/ConfigurazioneApi'
import { CHIAVI_SESSIONE } from 'configuration/ConfigurazioneSessione'
import { useSessione } from 'context/SessioneProvider'
import { useRichiestaServerLogged } from 'hook/useRichiestaServerLogged'

export default function useLogout(props = {}) {
  const {
    testoBottone,
    propsBottone,
    eseguiPrimaDelLogout,
  } = props

  const {
    [CHIAVI_SESSIONE.CHIAVE_ROTTA_HOME_SERVIZIO]: chiaveRottaHomeServizio
  } = useSessione()

  const [messaggioErrore, setMessaggioErrore] = useState(null)

  const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer
  } = useRichiestaServerLogged()

  async function logout() {
    eseguiPrimaDelLogout?.()

    const { ok, data } = await inviaOperazione(OPERAZIONI.LOGOUT_SPID, {
      backUrl: chiaveRottaHomeServizio
    })
    if (ok) {
      const { esito, url, messaggi } = data
      if (esito && url) {
        window.location.href = url
        return
      }
      setMessaggioErrore(messaggi)
    }
    setTimeout(() => window.location.href = chiaveRottaHomeServizio, 5000)
  }

  const ScatolaMessaggiLogout = (
    <>
      {messaggioErrore && <BaseFeedbackConIcona.Errore messaggio={messaggioErrore} />}
      {ScatolaMessaggi}
    </>
  )

  const BottoneLogout = (
    <>
      <BaseButtons.Logout
        testo={testoBottone}
        variant='text'
        color='primary'
        onClick={logout}
        {...(inAttesaDelServer && { inAttesa: true, disabled: true })}
        {...propsBottone}
        {...sx(propsBottone, { p: 0 })}
      />

      {ScatolaMessaggiLogout}
    </>
  )

  return {
    logout,
    BottoneLogout,
    inAttesaLogout: inAttesaDelServer,
    ScatolaMessaggiLogout,
  }
}